import { c as _c } from "react/compiler-runtime";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslations } from "next-intl";
import { createRoomListingAction } from "../actions";
import { useToast } from "@/hooks/use-toast";
import { PORTFOLIOS_QUERY_KEYS } from "@/components/modules/portfolio/api/queries/usePortfolios";
import { LISTING_MATCHES_QUERY_KEYS } from "../queries/useListingMatches";
import type { ListingMatches } from "../schema";
import type { Query } from "@/types/queryTpes";
export const useNewRoomListingMutation = () => {
  const $ = _c(8);
  const {
    toast
  } = useToast();
  const t = useTranslations("modules.listings.addRoomListing");
  const queryClient = useQueryClient();
  let t0;
  if ($[0] !== queryClient) {
    t0 = response => {
      queryClient.invalidateQueries({
        queryKey: PORTFOLIOS_QUERY_KEYS.all
      });
      const listingId = response?.data?.id;
      if (listingId && response?.matchAlerts) {
        queryClient.setQueryData(LISTING_MATCHES_QUERY_KEYS.getListingMatches(listingId), {
          data: {
            matches: response.matchAlerts.matches,
            total: response.matchAlerts.total
          },
          metadata: {}
        });
      }
    };
    $[0] = queryClient;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t || $[3] !== toast) {
    t1 = () => {
      toast({
        title: t("errorTitle"),
        description: t("errorDescription"),
        variant: "destructive"
      });
    };
    $[2] = t;
    $[3] = toast;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t0 || $[6] !== t1) {
    t2 = {
      mutationFn: createRoomListingAction,
      onSuccess: t0,
      onError: t1
    };
    $[5] = t0;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return useMutation(t2);
};